<template>
  <!-- Prevents page reload on submit -->
  <v-form ref="searchForm" v-model="valid" @submit.prevent>

    <!-- Phone View -->
    <template v-if="$vuetify.breakpoint.xsOnly">
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-select v-model="searchField" :items="fieldOptions" label="Fields" outlined hide-details dense color="integrity" @change="resetValidation()">
            <template slot="append-outer">
              <v-btn icon small :class="{ 'gratitude--text': filtersActive }" @click="showAdvancedFilters = !showAdvancedFilters">
                <v-icon v-if="filtersActive">mdi-filter</v-icon>
                <v-icon v-else>mdi-filter-outline</v-icon>
              </v-btn>
            </template>
          </v-select>
        </v-col>
        <template v-if="isNameSearch">
          <v-col cols="6" class="pb-0 pr-1">
            <v-text-field v-model="lastNameText" label="Last Name" outlined dense :rules="lastNameRules" validate-on-blur hide-details="auto" color="integrity" />
          </v-col>
          <v-col cols="6" class="pb-0 pl-1">
            <v-text-field v-model="firstNameText" label="First Name" outlined dense :rules="firstNameRules" validate-on-blur hide-details="auto" color="integrity" />
          </v-col>
        </template>
        <template v-else>
          <v-col cols="12">
            <v-text-field v-model="searchText" :label="label" outlined dense :type="type" :rules="rules" :hint="hint" validate-on-blur hide-details="auto" color="integrity" @keydown="onKeyDown" />
          </v-col>
        </template>

        <v-col cols="12" :class="{ 'text-center': $vuetify.breakpoint.xsOnly}">
          <v-btn type="submit" color="integrity" class="white--text" :loading="loading" @click="handleSearchClick()">
            {{ buttonLabel }}
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <!-- End Phone View -->

    <!-- Tablet+ View -->
    <template v-else>
      <v-row>
        <v-col cols="3" class="pb-0 pr-1">
          <v-select v-model="searchField" :items="fieldOptions" label="Fields" outlined hide-details dense color="integrity" @change="resetValidation()" />
        </v-col>
        <template v-if="isNameSearch">
          <v-col cols="3" class="pr-1 pl-1">
            <v-text-field v-model="lastNameText" label="Last Name" outlined dense :rules="lastNameRules" validate-on-blur hide-details="auto" color="integrity" />
          </v-col>
          <v-col cols="3" class="pl-1">
            <v-text-field v-model="firstNameText" label="First Name" outlined dense :rules="firstNameRules" validate-on-blur hide-details="auto" color="integrity" />
          </v-col>
        </template>
        <template v-else>
          <v-col cols="6">
            <v-text-field v-model="searchText" :label="label" outlined dense :type="type" :rules="rules" :hint="hint" validate-on-blur hide-details="auto" color="integrity" @keydown="onKeyDown" />
          </v-col>
        </template>

        <v-col class="pt-0 pl-0 pt-sm-3" :class="{ 'text-center': $vuetify.breakpoint.xsOnly}">
          <v-btn type="submit" color="integrity" class="white--text" :loading="loading" @click="handleSearchClick()">
            {{ buttonLabel }}
          </v-btn>
        </v-col>
      </v-row>

    <!-- Tablet+ View Advanced Search Options -->
      <v-row>
        <v-col class="py-0 ma-1">
          <AdvancedOptions divider :options.sync="advancedFilters" @update="handleUpdatedFilters" />
        </v-col>
      </v-row>
    </template>

    <!-- Phone View Advanced Search Options -->
    <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="showAdvancedFilters" scrollable>
      <v-card>
        <v-card-title>Advanced Options</v-card-title>
        <v-card-text>
          <AdvancedOptions :options="advancedFilters" @update="handleUpdatedFilters" />
        </v-card-text>
        <v-card-actions>
          <v-btn text color="gratitude darken-1" @click="clearFilters">Clear</v-btn>
          <v-spacer />
          <v-btn color="green darken-1" text @click="showAdvancedFilters = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<style scoped>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
<script>
import AdvancedOptions from '@/components/Search/AdvancedOptions.vue';
import analyticsService from '@/services/shared/analyticsService.js';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SearchForm',
  components: { AdvancedOptions },
  data () {
    var fieldOpts = [
      { text: 'Client ID', value: -1, color: 'blue3' },
      { text: 'Name', value: 5 },
      { text: 'Business Name', value: 7 },
      { text: 'Address', value: 3 },
      { text: 'Phone', value: 4 },
      { text: 'Email', value: 2 }
    ];

    return {
      valid: false,
      loading: false,
      searchText: '',
      firstNameText: '',
      lastNameText: '',
      dlSelected: false,
      archivedOptions: [fieldOpts[1], fieldOpts[2]],
      defaultFieldOptions: fieldOpts,
      searchField: fieldOpts[1].value,
      showAdvancedFilters: false,
      advancedFilters: {
        searchArchived: false
      },
      fieldValues: {
        clientId: -1,
        name: 5,
        busName: 7,
        address: 3,
        phone: 4,
        email: 2
      },
      searchCriteria: {
        startsWith: 1,
        contains: 2
      },
      firstNameRules: [
        v => ((v && v.trim().length > 0) || (this.lastNameText && this.lastNameText.length > 0)) || 'A first or last name is required'
      ],
      lastNameRules: [
        v => ((v && v.trim().length > 0) || (this.firstNameText && this.firstNameText.length > 0)) || 'A first or last name is required'
      ],
      defaultRules: [
        v => (v && v.trim().length > 0) || 'This field is required'
      ]
    };
  },
  computed: {
    ...mapState('search', ['searchHistory']),
    isNameSearch: function () {
      return this.searchField === this.fieldValues.name;
    },
    isPhoneSearch: function () {
      return this.searchField === this.fieldValues.phone;
    },
    isClientIdSearch: function () {
      return this.searchField === this.fieldValues.clientId;
    },
    label: function () {
      if (this.isClientIdSearch) {
        return 'What client are you looking for?';
      } else if (this.searchField === this.fieldValues.busName) {
        return 'What business are you searching for?';
      } else if (this.searchField === this.fieldValues.address) {
        return 'What address are you searching for?';
      } else if (this.searchField === this.fieldValues.phone) {
        return 'What phone number are you searching for?';
      } else if (this.searchField === this.fieldValues.email) {
        return 'What email address are you searching for?';
      }

      return 'Search';
    },
    buttonLabel: function () {
      if (this.isClientIdSearch) {
        return 'Launch';
      } else {
        if (this.advancedFilters.searchArchived) return 'Search Archived';
        return 'Search';
      }
    },
    type: function () {
      if (this.searchField === this.fieldValues.clientId) {
        return 'number';
      } else {
        return 'text';
      }
    },
    hint: function () {
      if (this.isPhoneSearch) {
        return 'Only searching on numeric digits';
      }

      return '';
    },
    rules: function () {
      if (this.isPhoneSearch) {
        return this.phoneRules;
      }

      return this.defaultRules;
    },
    filtersActive: function () {
      return this.advancedFilters.searchArchived;
    },
    fieldOptions: function () {
      if (this.advancedFilters.searchArchived) return this.archivedOptions;
      else return this.defaultFieldOptions;
    },
    phoneRules: function () {
      var result = true;
      var text = this.getTextForSearch();
      if ((text || null) === null) result = 'This field is required.';
      else if (text.length < 5) result = 'Phone number searches require at least 5 digits to be effective.';

      return [
        v => result
      ];
    }
  },
  mounted: function () {
    if ((this.searchHistory || null) !== null && this.searchHistory.length > 0) {
      var mostRecent = this.searchHistory[this.searchHistory.length - 1];

      this.searchField = mostRecent.searchField;
      this.firstNameText = mostRecent.firstNameText;
      this.lastNameText = mostRecent.lastNameText;
      this.searchText = mostRecent.searchText;
      this.advancedFilters = mostRecent.filters;
    }
  },
  methods: {
    ...mapActions('search', ['performSearch', 'addToSearchHistory', 'clearSearchResults']),
    validate () {
      return this.$refs.searchForm.validate();
    },
    resetValidation () {
      this.$refs.searchForm.resetValidation();
    },
    lookupClient: function (clientId) {
      this.$router.push(`client/${clientId}`);
    },
    handleSearchClick: async function () {
      var isValid = this.validate();
      if (!isValid) return;

      await this.search();
    },
    clearFilters: function () {
      this.advancedFilters.searchArchived = false;
    },
    search: async function () {
      var fields = this.getSearchFields();
      this.loading = true;

      this.addToSearchHistory({
        searchField: this.searchField,
        firstNameText: this.firstNameText.trim(),
        lastNameText: this.lastNameText.trim(),
        searchText: this.searchText.trim(),
        filters: this.advancedFilters
      });

      if (this.isClientIdSearch) {
        analyticsService.sendEvent(this.$gtag, 'Launch Client', 'Search', 'Launch Client by ID');
        this.clearSearchResults();
        this.lookupClient(this.getTextForSearch());
      } else {
        analyticsService.sendEvent(this.$gtag, 'Button Click', 'Search', 'Search');
        await this.performSearch({ searchForm: fields, searchType: this.searchField, searchArchived: this.advancedFilters.searchArchived });
      }

      this.loading = false;
    },
    getNameFields: function () {
      var fields = [];
      if (this.firstNameText.trim() !== '') {
        fields.push({
          field: 5, // First name
          value: this.firstNameText.trim(),
          criteria: this.searchCriteria.startsWith
        });
      }

      if (this.lastNameText.trim() !== '') {
        fields.push({
          field: 6, // Last name
          value: this.lastNameText.trim(),
          criteria: this.searchCriteria.startsWith
        });
      }

      return fields;
    },
    getTextForSearch: function () {
      if (this.isPhoneSearch) {
        var r = this.searchText.replace(/[^\d]/g, '');

        return r.trim();
      } else return this.searchText.trim();
    },
    handleUpdatedFilters: function () {
      // Force select name search when searching archived clients.
      if (this.advancedFilters.searchArchived) {
        if (this.searchField === this.fieldValues.busName) {
          return;
        }

        this.searchField = this.fieldValues.name;
      }
    },
    getSearchFields: function () {
      if (this.searchField === this.fieldValues.name) {
        return this.getNameFields();
      }

      var text = this.getTextForSearch();
      var criteria = this.searchCriteria.contains;
      if (this.isPhoneSearch) {
        var len = text.trim().length;
        if (len >= 10) criteria = this.searchCriteria.startsWith;
      }

      return [{
        field: this.searchField,
        value: text,
        criteria: criteria
      }];
    },
    onKeyDown: function (event) {
      if (this.type === 'number') {
        // If its a number, we want to prevent the user from inputing any special number characters.
        // 'e' = 69, '+' = 187, '-' = 189, '.' = 190
        if (event.which === 69 || event.which === 187 || event.which === 189 || event.which === 190) {
          event.preventDefault();
        }
      }
    }
  }
};

</script>
